import { get, post, put, remove } from './api.service'

const service = {

  getSubjects (params: any) {
    return get('/subjects', params)
  },

	createSubject (params: any) {
		return post('/subjects', params);
	},


	updateSubject (id, params: any) {
		return put(`/subjects/${id}`, params);
	},

	deleteSubject (id) {
		return remove(`/subjects/${id}`);
	},
}

export default service
